const TREND_FEATURES = [
  {
    icon: "ri-map-pin-user-line",
    title: "Ücretsiz Keşif",
    desc: "Osmaniye ve çevresinde ücretsiz ölçüm ve keşif yapıyoruz. Uzman ekibimiz belirlenen günde yanınızda.",
  },
  {
    icon: "ri-draft-line",
    title: "Tasarım & Danışmanlık",
    desc: "Markanıza özel tasarım seçenekleri sunuyor, projeniz için en doğru çözümü birlikte belirliyoruz.",
  },
  {
    icon: "ri-medal-line",
    title: "Kaliteli Uygulama",
    desc: "İthal malzeme ve uzman montaj ekibiyle projeni en kısa sürede, en yüksek standartta hayata geçiriyoruz.",
  },
];

const TrendSection = () => (
  <section className="relative py-24 bg-[#1C1710] overflow-hidden">
    <div className="absolute inset-0 opacity-20">
      <img
        alt="Tabela Trendi"
        className="w-full h-full object-cover object-center"
        src="https://vipreklamdekorasyon.com/wp-content/uploads/2024/04/Ekran-goruntusu-2024-04-06-154323.png"
      />
    </div>

    <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <div className="anim-left">
          <div className="inline-flex items-center gap-2 bg-[#E6A800]/20 border border-[#E6A800]/30 px-4 py-2 mb-6">
            <span className="w-1.5 h-1.5 rounded-full bg-[#E6A800] animate-pulse" />
            <span className="font-head font-700 uppercase text-[#E6A800] text-xs tracking-[0.2em]">
              2025 Tabela Trendi
            </span>
          </div>
          <h2 className="font-head font-black uppercase text-white text-5xl md:text-6xl leading-[0.9] mb-6">
            Trendin
            <br />
            <span className="text-[#E6A800]">Tabelası</span>
            <br />
            Sizde Olsun
          </h2>
          <p className="text-white/60 text-sm leading-relaxed mb-8 max-w-sm">
            2025 yılının en popüler tabela trendlerini yakından takip ediyoruz.
            Markanızı ön plana çıkaracak modern, ışıklı ve dikkat çekici tabela
            çözümleri için hemen iletişime geçin.
          </p>
          <a
            href="tel:+905511830918"
            className="inline-flex items-center gap-3 px-7 py-4 btn-red font-head font-700 uppercase tracking-wider text-sm cursor-pointer whitespace-nowrap group"
          >
            <i className="ri-phone-line text-sm" />
            Hemen Arayın
            <i className="ri-arrow-right-line group-hover:translate-x-1 tr" />
          </a>
        </div>

        <div className="space-y-4 anim-right d2">
          {TREND_FEATURES.map((f) => (
            <div
              key={f.title}
              className="flex items-start gap-4 p-5 bg-white/5 border border-white/10 hover:border-[#E6A800]/50 hover:bg-white/8 tr group"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-[#E6A800]/20 group-hover:bg-[#E6A800] tr shrink-0">
                <i className={`${f.icon} text-[#E6A800] group-hover:text-white text-sm tr`} />
              </div>
              <div>
                <h4 className="font-head font-700 uppercase text-white text-sm tracking-wide mb-1">
                  {f.title}
                </h4>
                <p className="text-white/50 text-xs leading-relaxed">{f.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default TrendSection;